import {Injectable, OnInit} from '@angular/core';
import {Router, CanActivate, NavigationExtras, ActivatedRouteSnapshot} from '@angular/router';
import {JwtHelper} from 'angular2-jwt';
import {Token} from '../models/token';
import {AuthControllerService} from '../services/auth-controller/auth-controller.service';
import {PageLayoutWidget} from '../components/widgets/page-layout/page-layout.component';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate, OnInit {
    static expiredTokenRefreshTimer;

    jwtHelper: JwtHelper = new JwtHelper();

    constructor(private router: Router,
                private authService: AuthControllerService) {
    }

    ngOnInit() {
		this.canActivate = this.canActivate.bind(this);
        this.authService.subscribeForTokenChange(this.canActivate);
        this.canActivate();
	}
	
	ngOnDestroy(): void {
		this.authService.unsubscribe(this.canActivate);
	}


    canActivate(route?: ActivatedRouteSnapshot): Observable<boolean>|boolean {

        const authService = this.authService;
        const searchParameters = this.authService.getSearchParameters();

        const error = searchParameters.error;


        if (error) {
            this.router.navigate(['/login'], {queryParams: {error: error}})
        }

        const token = searchParameters.token;
        if (token && authService.isValid(token)) {
            authService.saveAuthToken(token);
        }

        if (!AuthGuard.expiredTokenRefreshTimer) {
            AuthGuard.expiredTokenRefreshTimer = setInterval(() => {
                if (this.authService.isAnyTokenPresent() && authService.savedTokenIsAboutToExpireIn5Minutes()) {
                    this.refreshToken(this.authService)
                }
            }, 1000);
        }

		const authenticationCode = searchParameters.code;
		const expectedRoles = route && route.data && route.data.expectedRoles;
        if (!authService.isAnyTokenPresent() && authenticationCode) {
            this.authService.login(authenticationCode).subscribe(
                (resp) => {
                    PageLayoutWidget.messagesFromAuth = PageLayoutWidget.messagesFromAuth.concat(resp.messages.map(it => it.message));
                },
                (err) => {
                    this.authService.logout();
                }
			);
			if (!authService.userRoles.length && expectedRoles && expectedRoles.length) {
				return this.resolveRoles(expectedRoles);
			}
            return true
        }

        if (!authService.isAnyTokenPresent()) {
            this.authService.logout();
            return false;
        }

        if (authService.savedTokenHasExpired()) {
            return this.refreshToken(authService);
        }

        if (authService.isSavedTokenValid()) {
			if (expectedRoles && expectedRoles.length) {
				return this.resolveRoles(expectedRoles);
			}
            return true;
		}
		if (!authService.userRoles.length) {
			return this.resolveRoles(expectedRoles);
		}

        return true;
	}

	private resolveRoles(expectedRoles) {
		return this.authService.askRolesObservable().map(() => {
			return expectedRoles.some(this.authService.resolveRole, this.authService);
		});
	}
	
    private refreshToken(authService) {
        if (authService.savedRefreshToken()) {
            authService.refreshToken().subscribe(
                (data) => {
                    if (data === false) {
                        this.authService.logout();
                    }
                    return true;
                },
                (error) => {
                    this.authService.logout();
                    return false;
                }
            );
            return true;
        }
    }
}





// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts